import { Row, Col, Modal, Form, Input, Image } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import SingleImageUpload from "../../components/SingleImageUpload";
import notfound from "../../assets/images/not_found.png";

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                  =   Form.useForm();
  const { request }             =   useRequest();
  const [loading, setLoading]   =   useState(false);
  const [image, setImage]       =   useState([]);
  const FileType                =   ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/svg", "image/gif"]

  const handleImage = (data) =>{
    setImage(data);
  }

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data])

  const onCreate = (values) => {
    
    const payload = {
      ...values,
      image: image && image[0] ? image[0].url : null,
    }

    setLoading(true);
    request({
      url: `${data ? path + "/" + data._id : path}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    })
  };

  return (
    <Modal
      open = {show}
      title = {`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText = "Ok"
      onCancel = {hide}
      okButtonProps = {{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        
        <Row gutter={[16, 16]}>
          
          <Col span={24} xs={12} sm={12} md={24}>
            
            <Form.Item
              label = "Name"
              name = "name"
              normalize = {value => value.trimStart()}
              rules = {[
                { required: true, message: "Please Enter the name!" },
                { max: 255, message: "Name should not contain more then 255 characters!" },
                { min: 2, message: "Name should contain at least 2 characters!" }
              ]}
            >
              <Input autoComplete="off" placeholder={`Enter ${sectionName} Name`} />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={24}>
            <Form.Item label="Upload Image" name='image'>
                <SingleImageUpload
                  value={image}
                  fileType={FileType}
                  imageType={'brand'}
                  btnName={'Image'}
                  onChange={(data) => handleImage(data)}
                />
            </Form.Item>

            { image && <Image className="mt-2" width={120} src={image ? image : notfound} /> }
          
          </Col>

        </Row>

      </Form>
    </Modal>
  )
};

export default From;